import { Box, Typography } from "@mui/material";

interface StarRatingProps {
  stars: number;
  reviewCount: number;
}

export const StarRating = ({ stars, reviewCount }: StarRatingProps) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: 1,
      marginY: 1,
    }}
  >
    {stars}
    {/* Star Rating */}
    <Box
      sx={{
        display: "flex",
        position: "relative",
        alignItems: "center",
      }}
    >
      {/* Background empty stars */}
      <Box sx={{ display: "flex", color: "#E0E0E0" }}>{"★★★★★"}</Box>

      {/* Foreground filled stars with clipping */}
      <Box
        sx={{
          display: "flex",
          color: "#FFA41C",
          position: "absolute",
          top: 0,
          left: 0,
          overflow: "hidden",
          width: `${(stars / 5) * 100}%`,
        }}
      >
        {"★★★★★"}
      </Box>
    </Box>

    {/* Number of Reviews */}
    <Typography
      component="span"
      sx={{
        fontSize: 14,
        color: "#555",
        lineHeight: 1,
        display: "flex",
        alignItems: "center",
      }}
    >
      {reviewCount?.toLocaleString() || "0"} reviews
    </Typography>
  </Box>
);
